var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginUserProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .login_user {\n        fill: #55abdd;\n      }\n\n      .login_user2 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile_Pic",
    transform: "translate(-0.046 -0.354)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    className: "login_user",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(0.046 0.354)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    transform: "translate(13.261 11.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    transform: "translate(2.403 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    className: "login_user2",
    d: "M738.954,106.088A5.088,5.088,0,1,1,733.866,101,5.088,5.088,0,0,1,738.954,106.088Z",
    transform: "translate(-728.778 -101)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    className: "login_user2",
    d: "M736.448,120l3.18,1.272.636,5.724H725l.636-5.724,3.18-1.272",
    transform: "translate(-725 -107.915)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginUserProfileIcon);
export default __webpack_public_path__ + "static/media/login_user_profile_icon.3e1ff4b093179c36d716dba654778a66.svg";
export { ForwardRef as ReactComponent };